import { gql } from '@apollo/client';

export const confirmInviteV2Mut = gql`
    mutation confirmInviteV2(
        $agbAccepted: Boolean!
        $activationToken: String!
        $password: String!
        $passwordConfirmation: String!
        $mobile: String
        $street: String
        $streetNr: String
        $zipCode: String
        $city: String
        $country: String
    ) {
        confirmInviteV2(
            agbAccepted: $agbAccepted
            activationToken: $activationToken
            password: $password
            passwordConfirmation: $passwordConfirmation
            mobile: $mobile
            street: $street
            streetNr: $streetNr
            zipCode: $zipCode
            city: $city
            country: $country
        ) {
            success
        }
    }
`;

export const initiatePasswordResetV2Mut = gql`
    mutation initiatePasswordResetV2($email: String!) {
        initiatePasswordResetV2(email: $email) {
            success
        }
    }
`;


export const resendActivationLinkMut = gql`
    mutation resendActivationLink($email: String!) {
        resendActivationLink(email: $email)
    }
`;

export const resetPasswordV2Mut = gql`
    mutation resetPasswordV2(
        $resetToken: String!
        $password: String!
        $passwordConfirmation: String!
    ) {
        resetPasswordV2(
            resetToken: $resetToken
            password: $password
            passwordConfirmation: $passwordConfirmation
        ) {
            success
        }
    }
`;


export const signInV2Mut = gql`
    mutation signInV2($email: String!, $password: String!) {
        signInV2(email: $email, password: $password) {
            token
        }
    }
`;

export const getActivationTokenData = gql`
    query getActivationTokenData($activationToken: String!) {
        getActivationTokenData(activationToken: $activationToken) {
            selectedMandant {
                _id
                name
            }
            selectedMandantSettings {
                registrationEnabled
                newUserEnterMobile
                newUserEnterAddress
            }
            me {
                _id
                firstName
            }
            agbLink {
                _id
                url
            }
        }
    }
`;

export const userOfMandant = gql`
    query userOfMandant($mandantId: ID!, $userId: ID!) {
        userOfMandant(mandantId: $mandantId, userId: $userId) {
            _id
            address {
                street
                streetNr
                zipCode
                city
                country
            }
            email
            firstName
            lastName
            mobile
            role(mandantId: $mandantId) {
                _id
                role
                credits
                createdAt
            }
        }
    }
`;

export const usersOfMandant = gql`
    query usersOfMandant(
        $mandantId: ID!
        $orderBy: String
        $offset: Int
        $limit: Int
        $searchString: String
        $excludedUsergroupId: ID
        $filterByUsergroupId: ID
    ) {
        usersOfMandant(
            mandantId: $mandantId
            orderBy: $orderBy
            offset: $offset
            limit: $limit
            searchString: $searchString
            excludedUsergroupId: $excludedUsergroupId
            filterByUsergroupId: $filterByUsergroupId
        ) {
            total
            numMatch
            users {
                _id
                email
                emailConfirmed
                firstName
                lastName
                mobile
                numTlc
                role(mandantId: $mandantId) {
                    _id
                    role
                    createdAt
                    credits
                }
            }
        }
    }
`;
